import ReviewsTabHeader from './header/ReviewsTabHeader';
import AutomatedReviewLogsSection from './sections/automatedReviewLogs/AutomatedReviewLogsSection';
import GuestReviewTemplatesSection from './sections/guestReviewTemplates/GuestReviewTemplatesSection';

const ReviewsTab = () => {
  return (
    <>
      <ReviewsTabHeader />
      <GuestReviewTemplatesSection />
      <AutomatedReviewLogsSection />
    </>
  );
};

export default ReviewsTab;
